import { render, staticRenderFns } from "./EditCustomfieldModal.vue?vue&type=template&id=b9624ad6&scoped=true&"
import script from "./EditCustomfieldModal.vue?vue&type=script&lang=ts&"
export * from "./EditCustomfieldModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditCustomfieldModal.vue?vue&type=style&index=0&id=b9624ad6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9624ad6",
  null
  
)

export default component.exports